import React, { useEffect, useState } from "react";
import "./App.css";
import Sidebar from "./Sidebar";
import Chat from "./Chat";
import Pusher from "pusher-js";
import axios from "./axios";

function App() {
  const [messages, setMessages] = useState();
  const [lastmessage, setLastMessage] = useState();
  const [rooms, setRooms] = useState();

  useEffect(() => {
    axios.get("/messages/sync").then((response) => {
      setMessages(response.data);
    });
  }, []);

  useEffect(() => {
    axios.get("/rooms/sync").then((response) => {
      setRooms(response.data);
    });
  }, []);

  useEffect(() => {
    axios.get("/messages/last").then((res) => {
      setLastMessage(res.data);
    });
  }, []);

  useEffect(() => {
    const pusher = new Pusher("47911a077bc8510ac310", {
      cluster: "eu",
    });

    const channel = pusher.subscribe("messages");
    channel.bind("inserted", (newMessage) => {
      setMessages([...messages, newMessage]);
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, [messages]);

  console.log(lastmessage);

  return (
    <div className="app">
      <div className="app__body">
        <Sidebar rooms={rooms} lastmessage={lastmessage} />
        <Chat messages={messages} />
      </div>
    </div>
  );
}

export default App;
